import { TutoringRequestUser } from 'logic/api-models/api-models';

export const getUserNameLabel = (
  user: Pick<TutoringRequestUser, 'firstName' | 'lastName'> | undefined
) => `${user?.firstName || ''} ${user?.lastName ? `${user.lastName[0]}.` : ''}`;

export const getUserFullName = (
  user: Pick<TutoringRequestUser, 'firstName' | 'lastName'> | undefined
) => `${user?.firstName || ''} ${user?.lastName || ''}`;
